import {
    BASE_URL,
    MFA_ENROLMENT,
    PATCH,
    POST,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import {getAccessToken} from "../../authActions/authActions";
  
  export const sendEmailOTP = async(payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${MFA_ENROLMENT}send-otp`;
    return fetch(resource, {
      method: POST,
      headers: {
        // "Content-Type": "application/json",
        "userauth" : `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
    .then(statusParsing)
    .then(jsonParsing)
  };

  export const varifyEmailOtp = async(payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${MFA_ENROLMENT}verify-otp`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
    .then(statusParsing)
    .then(jsonParsing)
    .catch(async (error) => {
    if (error.response && error.response.status === 401) {
      const errorResponse = await error.response.json();
      return Promise.reject({
        message: errorResponse.message,
        code: errorResponse.code
      });
    }
    return Promise.reject(error);
    });
  };

  export const updateMfaType = async(payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${MFA_ENROLMENT}update-mfa-type`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
    .then(statusParsing)
    .then(jsonParsing)
  };

  export const varifyEmailcustomTokenOtp = async(token,payload) => {
    const resource = `${BASE_URL}${MFA_ENROLMENT}verify-custom-token-otp`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
    .then(statusParsing)
    .then(jsonParsing)
    .catch(async (error) => {
    if (error.response && error.response.status === 401) {
      const errorResponse = await error.response.json();
      return Promise.reject({
        message: errorResponse.message,
        code: errorResponse.code
      });
    }
    return Promise.reject(error);
    });
  }